import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const CREATE_QUERY = print(gql`
  mutation CreateFacultyMember($data: CreateFacultyMemberInput!) {
    createFacultyMember(data: $data) {
      id
    }
  }
`);

export interface CreateGql {
  createFacultyMember: {
    id: number;
  };
}
